import { createContext, useContext, useState, ReactNode } from 'react';

interface IPackageProContext {
  hasPackagePro: boolean;
  verificationSaved: boolean;
  setHasPackagePro: (value: boolean) => void;
  setVerificationSaved: (value: boolean) => void;
}

const PackageProContext = createContext<IPackageProContext>({
  hasPackagePro: false,
  verificationSaved: false,
  setHasPackagePro: () => {},
  setVerificationSaved: () => {},
});

export const PackageProProvider = ({ children }: { children: ReactNode }) => {
  const [hasPackagePro, setHasPackagePro] = useState(false);
  const [verificationSaved, setVerificationSaved] = useState(false);

  return (
    <PackageProContext.Provider
      value={{
        hasPackagePro,
        verificationSaved,
        setHasPackagePro,
        setVerificationSaved,
      }}
    >
      {children}
    </PackageProContext.Provider>
  );
};

export default PackageProContext;

